import type { Moment } from '@this/src/lib/moment';
import moment from 'moment';
import { observable } from 'mobx';

export type FlightSegmentTerminalResponseArgs = {
  code: string;
  date: string;
  datetime: string;
  name: string;
  time: string;
  time_zone: string;
};

export type FlightSegmentTerminalArgs = {
  code: string;
  date: string;
  datetime: Moment;
  name: string;
  time: string;
  timeZone: string;
};

export const convertFlightSegmentTerminalResponseToArgs = (response: FlightSegmentTerminalResponseArgs) => {
  const args: FlightSegmentTerminalArgs = {
    code: response.code,
    date: response.date,
    datetime: moment(response.datetime),
    name: response.name,
    time: response.time,
    timeZone: response.time_zone
  };
  return args;
};

export default class FlightSegmentTerminal {
  @observable code: string;
  @observable date: string;
  @observable datetime: Moment;
  @observable name: string;
  @observable time: string;
  @observable timeZone: string;

  constructor(args: FlightSegmentTerminalArgs) {
    this.code = args.code;
    this.date = args.date;
    this.datetime = args.datetime;
    this.name = args.name;
    this.time = args.time;
    this.timeZone = args.timeZone;
  }
}
